import React, { FC } from 'react';
import { FluidObject } from 'gatsby-image';

import * as S from './styles/productCardStyles';

interface Props {
  title: string;
  price: string;
  description: string;
  image: FluidObject;
}

const ProductCard: FC<Props> = ({
  title,
  price,
  description,
  image,
  children,
}) => {
  return (
    <S.Container>
      {/* @ts-ignore */}
      <S.ProductImage fluid={image} alt={title} />
      <S.Details>
        <S.ProductTitle>{title}</S.ProductTitle>
        <S.ProductPrice>{`$${parseInt(price)}`}</S.ProductPrice>
        <S.Description>{description}</S.Description>
        {children}
      </S.Details>
    </S.Container>
  );
};

export default ProductCard;
